import { createFileRoute, Navigate } from "@tanstack/react-router";
import { object, string } from "zod";

export const Route = createFileRoute("/(authless)/invite")({
  component: RouteComponent,
  validateSearch: object({ refer: string().optional() }),
});

function RouteComponent() {
  const { refer } = Route.useSearch();

  if (refer) {
    return <Navigate to="/signup/distributor" search={{ refer }} />;
  }
  return <Navigate to="/login/distributor" />;
}
